import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgModule } from '@angular/core'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { ErrorMessagesComponent } from './error-messages.component'
import { ValidatedTextField } from './validated-text-field.component'
import { ValidatedCheckboxComponent } from './validated-checkbox.component'
import { MaskedValidatedTextFieldComponent } from './masked-validated-text-field.component'
import { ValidatedDropDown } from './validated-dropdown.component'
import { ValidatedMultiSelect } from './validated-multi-select.component'
import { ConfirmPasswordTextField } from './confirm-password-text-field.component'
import { ValidatedSSNInputFields } from './validated-ssn-input-fields.component'
import { ObfuscatedTextField } from './obfuscated-text-field.component'
import { ValidatedDateTextField } from './validated-date-text-field.component'
import { ValidatedRadioButtonGroupComponent } from './validated-radio-button-group.component'
import { ValidatedRequestTextField } from './validated-request-text-field.component'
import { ValidatedStateDropdown } from './validated-state-dropdown.component'
import { ValidatedCheckboxGroupComponent } from './validated-checkbox-group.component'

@NgModule({ declarations: [
        ErrorMessagesComponent,
        ValidatedTextField,
        ValidatedCheckboxComponent,
        MaskedValidatedTextFieldComponent,
        ValidatedDropDown,
        ValidatedMultiSelect,
        ConfirmPasswordTextField,
        ValidatedSSNInputFields,
        ObfuscatedTextField,
        ValidatedDateTextField,
        ValidatedRadioButtonGroupComponent,
        ValidatedRequestTextField,
        ValidatedStateDropdown,
        ValidatedCheckboxGroupComponent
    ],
    exports: [
        ErrorMessagesComponent,
        ValidatedTextField,
        ValidatedCheckboxComponent,
        MaskedValidatedTextFieldComponent,
        ValidatedDropDown,
        ValidatedMultiSelect,
        ConfirmPasswordTextField,
        ValidatedSSNInputFields,
        ObfuscatedTextField,
        ValidatedDateTextField,
        ValidatedRadioButtonGroupComponent,
        ValidatedRequestTextField,
        ValidatedStateDropdown,
        ValidatedCheckboxGroupComponent
    ], imports: [CommonModule, FormsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ValidationModule {}
